import * as React from 'react';
import InputContainer from 'src/modules/commons/inputs/input/Input.container';
import ReactDropzone, { ImageFile } from 'react-dropzone';
import '../../physical-person-update/forms/Dropzone.css';
import FileImage from 'src/modules/commons/images/FileImage.component';
import SectorOfInterest from 'src/entities/SectorOfInterest';
import JuridicalPersonData from 'src/value-objects/JuridicalPersonData';

export interface JuridicalProfileFormComponentProps {
  formData: JuridicalPersonData;
  handleChange: (key: string) => (value: string | File | boolean | SectorOfInterest) => void;
  profilePicture?: File;
}

class JuridicalProfileFormComponent extends React.Component<JuridicalProfileFormComponentProps> {

  public render(): React.ReactNode {

    return (
      <section>
        <div
          className="accordion-toggle question-toggle collapsed pointer"
          data-toggle="collapse"
          data-parent="#faqAccordion"
          data-target="#question49"
        >
          <div className="icon-title">
            <img
              alt="More"
              className="icon"
              src="/img/user-check.png"
            />
            <h4 className="inline-block f-s-18">
              <strong>
                Tu perfil de usuario
              </strong>
              <span className="d-arrow-up"/></h4>
            <div className="gap-20"/>
          </div>
        </div>
        <div
          id="question49"
          className="collapse"
        >
          <div className="row">
            <div className="col-sm-6 col-md-4">
              <ReactDropzone
                className="dropzone text-center pointer"
                onDrop={(files: ImageFile[]) => {
                  if (files[0]) {
                    this.props.handleChange('profilePicture')(files[0]);
                  }
                }}
                multiple={false}
                accept="image/*"
              >
                <FileImage
                  alt="profile picture"
                  image={this.props.profilePicture}
                  defaultImagePath="/img/pic.png"
                />
                <div className="gap-10"/>
                <p className="text-center">
                  Arrastre su foto de perfil / Clique aquí...
                </p>
              </ReactDropzone>
              <div className="gap-20"/>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-6 col-md-4">
              <div className="md-input">
                <InputContainer
                  label="Usuario Facebook"
                  type="text"
                  value={this.props.formData.facebookProfile || ''}
                  required={false}
                  onChange={(value) => this.props.handleChange('facebookProfile')(value)}
                />
              </div>
              <div className="gap-20"/>
            </div>
            <div className="col-sm-6 col-md-4">
              <div className="md-input">
                <InputContainer
                  label="Usuario Twitter"
                  type="text"
                  value={this.props.formData.twitterProfile || ''}
                  required={false}
                  onChange={(value) => this.props.handleChange('twitterProfile')(value)}
                />
              </div>
              <div className="gap-20"/>
            </div>
            <div className="col-sm-6 col-md-4">
              <div className="md-input">
                <InputContainer
                  label="Usuario LinkedIn"
                  type="text"
                  value={this.props.formData.linkedinProfile || ''}
                  required={false}
                  onChange={(value) => this.props.handleChange('linkedinProfile')(value)}
                />
              </div>
              <div className="gap-20"/>
            </div>
          </div>
          <div className="gap-20"/>
        </div>
      </section>
    );
  }
}

export default JuridicalProfileFormComponent;


// WEBPACK FOOTER //
// ./src/modules/my-account/juridical-profile-update/forms/JuridicalProfileForm.component.tsx